import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useUser } from '../../contexts/UserContext';
import './SubscriptionStyles.css';

function SubscriptionSuccessPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { refreshUser } = useUser();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    // Refresh user profile to get updated tier
    refreshUser();

    // Countdown and redirect
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/subscription');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate, refreshUser]);

  const sessionId = searchParams.get('session_id');

  return (
    <div className="subscription-result-page success">
      <div className="result-card">
        <div className="success-icon">&#10003;</div>
        <h1>Subscription Successful!</h1>
        <p>Thank you for subscribing. Your account has been upgraded.</p>

        <div className="result-details">
          <p>Your new features are now active.</p>
          {sessionId && (
            <p className="session-id">Session ID: {sessionId.slice(0, 20)}...</p>
          )}
        </div>

        <div className="redirect-notice">
          <p>Redirecting to subscription management in {countdown} seconds...</p>
        </div>

        <div className="result-actions">
          <button className="primary-button" onClick={() => navigate('/subscription')}>
            View Subscription
          </button>
          <button className="secondary-button" onClick={() => navigate('/')}>
            Go to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
}

export default SubscriptionSuccessPage;
